(ns ycweb.app.website.myaccount.aftersales.confirm
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

;Aftersales Validate Save ====================================================================================================================================

(defn validate-aftersale-form [aftersale-case]
  (let [return-option (:aftersale/return-option aftersale-case)
        collection-address (:collection/address (:aftersale/collection aftersale-case))
        caseValid?
        (boolean
          (and
            (or
              (u/presence (:aftersale/refund-type aftersale-case))
              (= (:aftersale/type aftersale-case) :repair))
            (u/presence return-option)))

        address-valid?
        (boolean
          (or
            (and
              (= return-option "yuppiechef")
              (u/presence (:address/address collection-address))
              (u/presence (:address/suburb collection-address))
              (u/presence (:address/city collection-address))
              (u/presence (:address/postal-code collection-address))
              (u/presence (:collection/date (:aftersale/collection aftersale-case))))

            (and
              (= return-option "partner")
              (u/presence (:ent/uuid (:aftersale/partner aftersale-case))))

            (and
              (= return-option "customer")
              (u/presence (:ent/uuid (:aftersale/store aftersale-case))))))
        valid? (and caseValid? address-valid?)]

    valid?))

(defn submit-aftersale [app-atom aftersale]
  (let [items
        (->>
          (:aftersale/items aftersale)
          (map second)
          (filter :selected)
          (map #(select-keys % [:ent/uuid :aftersale-item/selected-qty :aftersale-item/faults])))

        aftersale
        (assoc aftersale :aftersale/items items)]
    (comms/ajax-post :web.myaccount/aftersale-submit {:aftersale aftersale})))

(defmethod grid/action :web.myaccount.aftersale/save [app-atom config _]
  (let [aftersale-case (:aftersale config)
        valid? (validate-aftersale-form aftersale-case)]

    (if valid?
      (do
        (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})
        (submit-aftersale app-atom aftersale-case))
      (toaster/open-toast app-atom :error "Please ensure all fields are completed" {:closetime 3000}))))

;Aftersales Confirm ====================================================================================================================================

;TODO: These checklist don't seem to cater for both returns and repairs correctly - copied as is
(rum/defc aftersales-checklist < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        aftersale-atom (rum/cursor-in process-atom [:aftersale])

        aftersale (rum/react aftersale-atom)

        aftersale-type (:aftersale/type aftersale)]
    (list
      [:div.form-field
       (forms/checkbox "I have repackaged it properly" (rum/cursor-in aftersale-atom [:checked :return_packed])
         {:id :return_packed
          :name :checklist_packaging
          :required? true
          :description
          [(str "Yuppiechef will not be liable for any damage to your appliance caused by shipping.
          Please ensure that you have packed the item to be " (if (= aftersale-type :repair) "repaired" "returned") "
          in its original packaging, if possible, AND in another box with as much padding and protective packaging as possible.")
           [:br]
           [:b "Unwanted items returned for refund will incur a repackaging fee (10% of item value) if not packed correctly."]
           [:br]
           (str "Any return of physical goods must include all accessories and instructions, and all original packaging that is still available.
If you are returning a set, please ensure you return all items within the set, even if not all items are problematic.")]})]
      [:div.form-field
       (forms/checkbox "I have checked the warranty" (rum/cursor-in aftersale-atom [:checked :returncosts])
         {:id :returncosts
          :name :checklist_costs
          :required? true
          :description "Any returns not covered by warranty will be quoted on, for your approval. We will require payment before any work is done."})]
      [:div.form-field.u-margin-bottom-40
       (forms/checkbox (str "I might need to pay for the " (if (= aftersale-type :repair) "repair" "return"))
         (rum/cursor-in aftersale-atom [:checked :returns_attachments])
         {:id :returns_attachments
          :name :checklist_warranty
          :required? true
          :description (str "Any " (if (= aftersale-type :repair) "repairs" "returns") " not covered by warranty will be
          quoted on, for your approval. We will require payment before any work is done.")})])))

(defn load-image [file-atom image-atom loader-atom app-atom]
  #?(:cljs
     (let [{:keys [file img]} @file-atom
           allowed-types (u/get-allowed-types :image)]
       (when (and (.-files file) (aget (.-files file) 0))
         (let [selected-file (aget (.-files file) 0)]
           (cond
             (contains? allowed-types (.-type selected-file))
             (let [reader (js/FileReader.)]
               (swap! loader-atom assoc :loading? true)
               (set! (.-onload reader)
                 (fn [e]
                   (let [b64 (.-result (.-target e))]
                     (swap! loader-atom assoc :loading? false)
                     (swap! image-atom assoc :encoded b64))))
               (.readAsDataURL reader (aget (.-files file) 0)))

             :else
             (toaster/open-toast app-atom :error "Please select a valid image file (JPG, PNG, or GIF)" {:closetime 3000})))))))

(rum/defc aftersales-refund-types [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        aftersale-atom (rum/cursor-in process-atom [:aftersale])]
    [(headings/heading "If possible I would prefer" {:type :h3 :size :small :class :yc-heading--section})
     [:div.form-section.form-section--max-width-480
      [:div.form-field
       (forms/radio "A Yuppiechef voucher so that I can buy something else" 0 (rum/cursor aftersale-atom :aftersale/refund-type))]
       ;;todo - only if not registry order
      [:div.form-field
       (forms/radio "The money back in my bank" 1 (rum/cursor aftersale-atom :aftersale/refund-type))]
      [:div.form-field
       (forms/radio "Please exchange the products for new ones" 2 (rum/cursor aftersale-atom :aftersale/refund-type))]]]))

(rum/defcs aftersales-file-uploads < rum/reactive (cmn/local {} ::image) [s app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        aftersale-atom (rum/cursor-in process-atom [:aftersale])
        images-atom (rum/cursor-in aftersale-atom [:aftersale/images])
        loader-atom (rum/cursor-in aftersale-atom [:images-loading])

        images (rum/react images-atom)
        loader (rum/react loader-atom)]
    [(headings/heading "Please provide some photos (optional)" {:type :h3 :size :small :class :yc-heading--section})
     [:div.form-section.form-section--max-width-480
      [:div.form-field
       [:div.file-input-wrapper
        [:span.form-label "Photos" ":"]

        ;;todo - the trash icon isn't in the right place - but might just be a sync issue - test again
        (for [[idx image] images]
          [:div.dope-file-input-preview
           [:img.image--full {:src (:encoded image) :alt "" :style {:max-width "240px"}}]
           [:a.dope-file-input-preview__option.icon-link.icon-block-link.icon-block-link--size-small
            {:on-click #(swap! images-atom dissoc idx)}
            [:i.icon.icon--block.icon--is-dark.icon--delete
             [:span.u-hidden-from-view "Delete this file"]]]])

        [:label
         {:class (u/bem :dope-file-input [(when (= (:loading? loader) true) :is-uploading)])}
         [:input.dope-file-input__field
          {:type "file"
           :accept "image/jpeg,image/jpg,image/png,image/gif,image/webp"
           :ref (fn [dom-or-nil] (swap! (::image s) assoc :file dom-or-nil))
           :on-change #(load-image (::image s) (rum/cursor-in images-atom [(u/uuid)]) loader-atom app-atom)
           :name "returnfiles"}]

         (cond
           (= (:loading? loader) true)
           [:span.dope-file-input__text
            [:span.dope-file-input__icon
             [:i.u-animate-spin {:class (u/bem :icon [:2-1 :loading :inline])}]]
            [:span {:class (u/bem :loading-text [:is-absolute])} "Uploading"]]

           :else
           [:span.dope-file-input__text
            [:span.dope-file-input__icon
             [:i
              {:class
               (u/bem :icon [:2-1 :upload :block])}]]
            [:span (if (> (count images) 0) "Upload another file" "Upload a file")]])]]
       [:div.form-hint-wrapper [:span.form-hint.js-form-hint "You can upload multiple photos"]]]]]))

(rum/defc aftersales-contact-details [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        aftersale-atom (rum/cursor-in process-atom [:aftersale])]
    [(headings/heading "Contact details" {:type :h3 :size :small :class :yc-heading--section})
     [:div.form-section.form-section--max-width-480
      (forms/input "Full name:" "e.g. Jane Smith" (rum/cursor-in aftersale-atom [:aftersale/contact :contact/name])
        {:type :user
         :id :collection_fullname
         :name :returncase_contactname
         :required? true
         :icon true})
       ;;todo if gift - get details from session?
      (forms/input "Contact number:" "e.g. 083 000 0000" (rum/cursor-in aftersale-atom [:aftersale/contact :contact/number])
        {:type :phone
         :id :collection_number
         :name :returncase_collectionnumber
         :required? true
         :icon true})
      (forms/input "Email address:" "e.g. jane.smith@domain.com" (rum/cursor-in aftersale-atom [:aftersale/contact :contact/email])
        {:type :email
         :id :collection_email
         :name :returncase_collectionemail
         :required? true
         :icon true})]]))

(rum/defc aftersales-collection-details < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        process-atom (cmn/process-cursor app-atom)
        aftersale-atom (rum/cursor-in process-atom [:aftersale])
        collection-address-atom (rum/cursor-in process-atom [:aftersale :aftersale/collection :collection/address])

        aftersale (rum/react aftersale-atom)
        partner-collection-points (cmn/curact action-atom [:partner-collection-points])
        partner-collection-point-addresses (cmn/curact action-atom [:partner-collection-addresses])
        stores (cmn/curact action-atom [:stores])

        partner-address (first (get partner-collection-point-addresses (:ent/uuid (:aftersale/partner aftersale))))
        store-address (first (get stores (:ent/uuid (:aftersale/store aftersale))))]

    [(headings/heading "Collection details" {:type :h3 :size :small :id :scrollto-collection-details :class :yc-heading--section})
     [:div.form-section.form-section--max-width-480
      [:div.form-field
       (forms/radio "Request to drop off at select PostNet stores" "partner" (rum/cursor aftersale-atom :aftersale/return-option)
         {:description "Our team will review and approve this request"})]
      (when (= (:aftersale/return-option aftersale) "partner")
        [:div.form-subsection
         [:div.u-max-width-320
          (forms/select "" (rum/cursor-in aftersale-atom [:aftersale/partner :partner/city])
            (into
              [{:text "Select a city"
                :value 0}]
              (map
                (fn [city]
                  {:text city
                   :value city})
                (keys partner-collection-points))))]

         [:div.u-max-width-320
          (forms/select "" (rum/cursor-in aftersale-atom [:aftersale/partner :ent/uuid])
            (into
              [{:text "Select a PostNet"
                :value 0}]
              (map
                (fn [point]
                  {:text (:ent/display-name point)
                   :value (:ent/uuid point)})
                (get partner-collection-points (:partner/city (:aftersale/partner aftersale)))))
            {:type :string})]

         (when partner-address
           [:p
            (:ent/display-name partner-address)
            [:br]
            (:address/suburb (:partner/address partner-address))
            [:br]
            (:address/city (:partner/address partner-address))
            [:br]
            (:address/postal-code (:partner/address partner-address))])])

      [:div.form-field.u-max-width-320
       (forms/radio "I will bring it to Yuppiechef" "customer" (rum/cursor aftersale-atom :aftersale/return-option))]

      (when (= (:aftersale/return-option aftersale) "customer")
        [:div.form-subsection
         [:div.u-max-width-320
          (forms/select ""
            (rum/cursor-in aftersale-atom [:aftersale/store :ent/uuid])
            (into
              [{:text "Select a store"
                :value 0}]
              (map
                (fn [[k store]]
                  {:text (:ent/display-name (first store))
                   :value k})
                stores))
            {:type :string})]
         (when store-address
           [:p.yc-paragraph.yc-paragraph--small
            [:b "Yupiechef " (:ent/display-name store-address)]
            " - " [:a.text-link
                   {:href (:address/maps-link (:store/address store-address)) :target "_blank"} "Map"]
            [:br]
            (:address/address (:store/address store-address))
            [:br]
            (:address/suburb store-address)
            [:br]
            (:address/city store-address)
            [:br]
            (:address/postal-code store-address)])])

      [:div.form-field.u-max-width-320
       (forms/radio "Collect from me" "yuppiechef" (rum/cursor aftersale-atom :aftersale/return-option)
         {:description "Yuppiechef will arrange to collect by courier"})]
      (when (= (:aftersale/return-option aftersale) "yuppiechef")
        [:div.form-subsection
         (forms/textarea "Address for collection:" (rum/cursor collection-address-atom :address/address)
           {:id :collection_address
            :name :returncase_collectionaddress
            :rows 3})
         (forms/input "Suburb:" "" (rum/cursor collection-address-atom :address/suburb)
           {:type :text
            :id :collection_suburb
            :name :returncase_collectionsuburb})
         (forms/input "City:" "" (rum/cursor collection-address-atom :address/city)
           {:type :text
            :id :collection_city
            :name :returncase_collectioncity})
         (forms/input "Postal code:" "" (rum/cursor collection-address-atom :address/postal-code)
           {:type :text
            :id :collection_postal
            :name :returncase_collectionpostal})
         (datepicker/datepicker app-atom "It'll be ready to collect on" "Pick a date"
           [:web.myaccount :aftersale :aftersale/collection :collection/date]
           {:disable-dow #{6 7}
            :datatype :datedmy
            :min-date (ud/business-days (ud/at-midnight (dt/now)) 2)})])]]))

(rum/defc aftersales-confirm-line < rum/reactive [app-atom aftersale-type [item-uuid item]]
  (let [process-atom (cmn/process-cursor app-atom)
        reason-codes (u/index-by :reason/code (cmn/curact process-atom [:reason-codes]))

        {:item-line/keys [variation product]} item
        faults (take (u/parseInt (or (:aftersale-item/selected-qty item) 1)) (:aftersale-item/faults item))]
    (when (:selected item)
      (map
        (fn [[idx fault]]
          [:tr.yc-tr {:key idx}
           [:td.yc-td.yc-td--product-image
            (web-common/lazy-image app-atom
              (:doc/public-id (:ent/image variation))
              {:class ["yc-td__image"]}
              {:w 100 :h 100})]
           [:td.yc-td.yc-td--product-text
            [:div.yc-td__product-name (:ent/display-name product)]]
           (when (= aftersale-type :repair)
             [:td.yc-td
              [:span.yc-td__faux-table {:data-th "Serial No."}
               [:span.yc-td__faux-td (:fault/serial-number fault)]]])
           (when (= aftersale-type :repair)
             [:td.yc-td
              [:span.yc-td__faux-table {:data-th "Fault"}
               [:span.yc-td__faux-td (:fault/reason-text fault)]]])
           (when (= aftersale-type :repair)
             [:td.yc-td
              [:span.yc-td__faux-table {:data-th "Usage"}
               [:span.yc-td__faux-td (:fault/usage-type fault)]]])

           (when (= aftersale-type :return)
             [:td.yc-td
              [:span.yc-td__faux-table {:data-th "Fault"}
               [:span.yc-td__faux-td (:reason/text (get reason-codes (:fault/reason-code fault)))]]])
           (when (= aftersale-type :return)
             [:td.yc-td
              [:span.yc-td__faux-table {:data-th "Reason"}
               [:span.yc-td__faux-td (:fault/reason-text fault)]]])])
        faults))))

(rum/defc aftersale-confirm-table < rum/reactive [app-atom aftersale-atom]
  (let [aftersale (rum/react aftersale-atom)
        aftersale-type (:aftersale/type aftersale)
        items (:aftersale/items aftersale)]
    [:table.yc-table.yc-table--order-view
     [:caption.yc-table-caption.hidden-from-view (str "Summary of your " (if (= aftersale-type :repair) "repair" "return") " request")]
     [:colgroup
      [:col {:style {:width "100px"}}]
      [:col]
      [:col]
      [:col {:style {:width "320px"}}]
      [:col]]
     [:thead.yc-thead
      [:tr.yc-tr
       [:th.yc-th {:scope "col"} "Item"]
       [:th.yc-th {:scope "col"} "Description"]
       [:th.yc-th {:scope "col"} (if (= aftersale-type :repair) "Serial No." "Return Reason")]
       [:th.yc-th {:scope "col"} (if (= aftersale-type :repair) "Fault Description" "Return Description")]
       (when (= aftersale-type :repair) [:th.yc-th {:scope "col"} "Usage"])]]

     (into
       [:tbody.yc-tbody]
       (map (partial aftersales-confirm-line app-atom aftersale-type) items))]))

(rum/defcs aftersales-confirm < rum/reactive (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        order-atom (rum/cursor-in process-atom [:client-order])
        aftersale-atom (rum/cursor-in process-atom [:aftersale])
        node-atom (::node-atom local-atom)

        order (rum/react order-atom)
        aftersale (rum/react aftersale-atom)

        aftersale-type (:aftersale/type aftersale)]
    [:div.dashboard
     (headings/heading (str "Confirm your " (if (= aftersale-type :repair) "Repair" "Return") " Request") {:type :h2 :size :medium})
     [:p.yc-paragraph.u-max-width-720
      "Please review the information below and change anything that needs updating."
      [:br]
      [:span.text-status--warning
       "We've used the same contact details from your previous order."]]
     (aftersale-confirm-table app-atom aftersale-atom)

     [:div.dashboard-footer
      (buttons/button-web (str "Edit your " (if (= aftersale-type :repair) "repairs" "returns"))

        (merge
          (urlstate/href-props app-atom "myaccount" "aftersalecreate"
            {:uuid (:ent/uuid order) :casetype (if (= aftersale-type :repair) "repair" "return")})
          {:style :secondary
           :size :small}))
      (buttons/button-web "Continue"
        {:on-click #(scroll/scroll-to-id % "scrollto-collection-details")
         :style :primary
         :size :small})]

     [:form
      {:ref (fn [node] (reset! node-atom node))}
      (aftersales-collection-details app-atom)
      (aftersales-contact-details app-atom)
      (when (= aftersale-type :return) (aftersales-refund-types app-atom))
      (when (= aftersale-type :return) (aftersales-file-uploads app-atom))
      (headings/heading (str (if (= aftersale-type :repair) "Repairs" "Returns") " checklist")
        {:type :h3 :size :small :class :yc-heading--section})
      [:p.yc-paragraph.u-max-width-720
       "Before we come to collect there are three things we need to be sure you have done, and understood.
       Please complete the checklist below and when you're ready, hit submit."]
      (aftersales-checklist app-atom)
      [:div.form-control

       (buttons/button-web "Submit"
         {:on-click
          (forms/form-validate node-atom #(grid/dispatch-action app-atom :web.myaccount.aftersale/save {:aftersale aftersale}))
          :type :button
          :style :primary
          :size :default})]]
     (toaster/loading-overlay app-atom :web.myaccount/aftersale-confirm)]))

(defmethod flow/render-screen :web.myaccount/aftersale-confirm [app-atom _]
  (awm.common/screen-wrapper app-atom
    (aftersales-confirm app-atom)))

(defmethod t/transition-open :web.myaccount/aftersale-confirm [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/aftersales-confirm)
  (comms/ajax-get :web.myaccount/collection-points {}))

(defmethod comms/receive :web.myaccount/collection-points [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/aftersale-confirm)
  (swap! (cmn/action-cursor app-atom) assoc
    :partner-collection-points (:partner-collection-points e)
    :partner-collection-addresses (:partner-collection-addresses e)
    :stores (:stores e)))

(defmethod comms/receive :web.myaccount/aftersale-submit [app-atom e]
  (toaster/close-toast app-atom)
  (if (:success e)
    (do
      (swap! (cmn/process-cursor app-atom)
        #(-> %
           (dissoc :aftersale)
           (assoc-in [:return-case] (:return-case e))))
      (t/transition-next app-atom :web.myaccount/aftersale-complete))
    (toaster/open-toast app-atom :error "Failed to submit return case." {:closetime 3000})))
